import React from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import { Outlet } from 'react-router-dom';

import MenuLateral from 'Component/Admin/MenuLateral';
import MenuSuperior from 'Component/Admin/MenuSuperior';
import Rodape from 'Component/Admin/Rodape';

import type { Props } from './index';

const Default = (props: Props): React.ReactElement => {
  return (
    <div
      className="bg-black d-flex flex-nowrap bg-light animate__animated animate__fadeIn"
      style={{ height: window.innerHeight }}
    >
      <MenuLateral />
      <div
        className="w-100 d-flex flex-column overflow-auto bg-dark flex-grow-1"
        style={{ paddingTop: 56 }}
      >
        <MenuSuperior />
        <section className="bg-light p-3 p-sm-4 d-flex flex-column flex-grow-1">
          <div className="p-sa-y d-flex flex-column flex-grow-1">
            {props.children}
            <Outlet />
          </div>
        </section>
        <BrowserView>
          <Rodape />
        </BrowserView>
        <MobileView style={{ marginBottom: '67px' }} />
      </div>
    </div>
  );
};

export default Default;
